<template>
	<div>
			<div class="side-menu-overlay" v-on:click="closeMenu" v-bind:class="{ active: isActive }"></div>
			<div class="side-menu-wrapper" v-bind:class="{ isRight: isRight, active: isActive }">
					<div class="menu-close">
							<button v-on:click="closeMenu" class="cross">
									<img src="/img/icons/menu/icon-close.svg" alt="cross" class="cross-image" />
							</button>
					</div>
					<div class="menu-content" v-bind:class="{ isRight: isRight }">
							<slot></slot>
					</div>
			</div>
	</div>
</template>

<script>
export default {
	props: {
			isActive: {
					type: Boolean,
					default: true,
			},
			closeMenu: {
					type: Function,
			},
			isRight: {
					type: Boolean,
					default: true,
			},
	},

	data: function () {
			return {}
	},
	watch: {
			isActive: function (val) {
					const html = document.getElementsByTagName("html")[0];

					if (val) html.classList.add('overflow-hidden-important');
					else html.classList.remove("overflow-hidden-important")
			},
	},
}
</script>

<style lang="scss">
@import '../../../sass/variables.scss';
.mobile-menu {
	display: block !important;
}
.side-menu-overlay {
	/* overlay */
	height: 100%;
	width: 0;
	position: fixed;
	z-index: 2001;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.7);
	overflow-y: auto;
	overflow-x: hidden;
	text-align: center;
	opacity: 0;
	transition: opacity 1s;
	&.active {
			width: 100%;
			opacity: 1;
	}
}

.side-menu-wrapper {
	/* style menu wrapper */
	overflow: hidden;
	position: fixed; /* Fixed position */
	top: 0;
	left: -475px; /* Sidebar initial position. "right" for right positioned menu */
	height: 100%;
	z-index: 2002;
	transition: 0.35s; /* CSS transition speed */
	width: 475px;
	display: flex;
	flex-direction: column;
	background-color: $dark;
	color: white;

	@media (max-width: $breakpoint-header) {
			width: 100%;
			left: -100%;
	}

	&.active {
			left: 0;
	}

	&.isRight {
			right: -550px;

			@media (max-width: $breakpoint-header) {
					right: -100%;
			}

			&.active {
					right: 0;
					left: initial;
			}

			.menu-close {
					justify-content: flex-end;
			}
	}

	.menu-content {
			width: 100%;
			height: 100%;
			overflow-y: auto;
			display: flex;
			justify-content: center;
			&.isRight {
					text-align: right;
			}

			.btn.btn-primary {
					height: 43px;
			}
	}

	.menu-close {
			margin: 22px;
			font-size: 45px;
			display: flex;

			.cross {
					text-align: center;
					&-image {
							width: 22px;
							height: 22px;
					}
			}

			@media (max-width: $breakpoint-header) {
					margin: 1rem 20px;
			}

	}

	@media (min-width: $navbar-breakpoint) {
					.menu-close{
							justify-content: start;
					}
			}

}
</style>
